import { Pipe, PipeTransform } from '@angular/core';
import Event from '../../../core/models/event';

// Legacy category names carry an emoji prefix ("🎤 Comedia") while v3's
// don't ("Comedia"), so compare on the bare name.
const bareName = (name: string) => name.replace(/^[^\p{L}]+/u, '').trim();

@Pipe({
  name: 'filterByCategory',
})
export class FilterByCategoryPipe implements PipeTransform {
  transform(eventList: Event[], category: string = 'Todos'): Event[] {
    if (category === 'Todos') return eventList;
    const wanted = bareName(category);
    return eventList.filter((event) => bareName(event.category.name) === wanted);
  }
}
